import { Component } from "preact";
import User from "./../User";

import style from "./index.scss";

export default class WidgetBody extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { payload, closeModal } = this.props;
    return (
      <div>
        <div
          id="innerLoaderId"
          style={{ display: "none" }}
          class={style.widgetBodyLoader}
        >
          <div></div>
        </div>
        <User closeModal={closeModal} payload={payload} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/WidgetBody/index.js